import {Directive, ElementRef, HostBinding, HostListener} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Directive({
    selector: '[appAriaTitle]'
})
export class AriaTitleDirective {

    @HostBinding('attr.title') title: string | null = null;

    constructor(
        private el: ElementRef,
        private translate: TranslateService
    ) {}

    @HostListener('click')
    @HostListener('focus')
    @HostListener('mouseenter')
    update() {
        const el = this.el.nativeElement;
        const pressed = el.getAttribute('aria-pressed') === 'true';
        const selected = el.getAttribute('aria-selected') === 'true';
        const current = el.hasAttribute('aria-current');

        if (pressed) {
            this.title = this.translate.instant('aria.pressed_title');
        } else if (selected) {
            this.title = this.translate.instant('aria.selected_title');
        } else if (current=== 'true' || current === 'page' || current === 'step') {
            this.title = this.translate.instant('aria.current_title');
        } else {
            this.title = null;
        }
    }
}
